/**
 * Created by Sukh on 13/11/2017.
 * Description: Global Computed Mixing for Profile
 */

;
import moment from "moment";

export default {
  methods: {
    getProfile() {
      let self = this,
        profileObj = self.$store.state.activeProfileObject;
      if (_.has(profileObj, 'information')) {
        return profileObj;
      }
    }
  },
  computed: {
    getUserInitials() {
      let self = this,
        data = self.getProfile(),
        basic = data.information.basic,
        firstname = basic.firstname.charAt(0),
        surname = basic.surname.charAt(0);
      return firstname + surname;
    },
    isAdmin() {
      let self = this;
      if (_.has(self.$store.state.user, 'user_role')) {
        return self.$store.state.user.user_role.role_id === 2;
      }
    },
    showPrivacyProgress() {
      let self = this;
      let data = self.getProfile();
      return (self.isOwner) || (!self.isOwner && data.privacy.progress);
    },
    showPrivacyQuestions() {
      let self = this,
        data = self.getProfile();
      return (self.isOwner) || (!self.isOwner && data.privacy.questions);
    },
    showPrivacyInfo() {
      let self = this,
        data = self.getProfile();
      return (self.isOwner === true) || (!self.isOwner && data.privacy.information);
    },
    showPrivacyFood() {
      let self = this,
        data = self.getProfile();
      return (self.isOwner === true) || (!self.isOwner && data.privacy.food);
    },
    isOwner() {
      let self = this;
      if (_.has(self.$store.state.user, 'scope')) {
        return self.$store.state.activeProfile === self.$store.state.user.scope.user_id;
      }
    },
    isGalleryEmpty() {
      let self = this;
      return self.getProfile().gallery.length === 0;
    },
    isBirthday() {
      let self = this;
      let date = moment().format('YYYY-M-D');
      return self.profile.dob === date;
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ProfileMixin/index.js